import type { SupplierPalletShipmentDispatchResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../hooks/api/v2/apiV2Request";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { ServerStateKeys } from "../../../hooks/api/v2/ServerStateKeys";

export const useSellarDistributionPalletDispatch = (id: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `distribution-pallet-shipment/${id}/dispatch`,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SupplierPalletShipmentDispatchResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
          id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
        ],
      });
    },
  });
};
